/* istanbul ignore file */

import allytm, { formatFeatureFlags } from '@ally/allytm'
import { AccountDetails } from '../../types'
import { useHostServices } from '../../HostServices'
import { useCustomer } from '../../hooks/use-customer'

export type SpendingBucketsFlow = 'createBucket' | 'editBucket'

export interface TaggingPrefix {
  taggingPrefix: SpendingBucketsFlow
}

const serverErrorEvent = (
  messageDisplayed: string,
  errorCode: string | number | undefined = 'null',
  isFormError = false,
): void => {
  allytm.event('customError', messageDisplayed, errorCode, {
    isFormError,
  })
}

export const accountDetailsServerErrors = {
  getDetailsFailure: (err: Error): void => {
    serverErrorEvent(
      'There was a problem loading your account information. Try again later.',
      err?.message,
      false,
    )
  },
}

interface AccountDetailsTagging {
  accountDetailsPageViewEvent: (details: AccountDetails) => void
}

export const useAccountDetailsTagging = (): AccountDetailsTagging => {
  const { featureFlags } = useHostServices()
  const { hasPaperDelivery } = useCustomer()
  const accountDetailsPageViewEvent = (details: AccountDetails): void => {
    allytm.event('pageview', `AOS:Account Details:${details.productId}`, {
      goPaperless: hasPaperDelivery() ? 'Y' : 'N',
      productNumber: details.productId,
      coverdraft: details.allowanceEligibilityReasonCd === 1 ? 'On' : 'Off',
      overdraftTransfer: details.otsAccounts?.length > 0 ? 'Y' : 'N',
      'Early Direct Deposit': details.earlyDirectEligibilityIndicator
        ? 'Y'
        : 'N',
      featureFlag: formatFeatureFlags(featureFlags, [
        {
          flagName: 'FF_spending-buckets-default-tab',
          defaultValue: 'spendingBuckets',
        },
      ]),
    })
  }

  return {
    accountDetailsPageViewEvent,
  }
}
